import { inject } from '@angular/core';
import { ResolveFn, Routes } from '@angular/router';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { firstValueFrom } from 'rxjs';
import { UserProfileService } from 'services';
import { LogoutComponent } from '../components/logout/logout.component';
import { UnauthorizedComponent } from '../components/unauthorized/unauthorized.component';
import { HomeComponent } from '../features/home/home.component';
import { UserProfile } from '../services/application-api.service';
import { RegionSummaryComponent } from '../features/region-summary/region-summary.component';
import { RoadmapComponent } from '../features/roadmap/roadmap.component';
import { SearchComponent } from '../features/search/search.component';

const userProfileResolver: ResolveFn<UserProfile | null> = async () => {
  return firstValueFrom(inject(UserProfileService).user$);
};

export const routes: Routes = [
  { path: '', canActivate: [autoLoginPartialRoutesGuard], resolve: { user: userProfileResolver }, children: [
    { path: '', redirectTo: 'home', pathMatch: 'full' },
    { path: 'home', component: HomeComponent },
    { path: 'search', component: SearchComponent },
    { path: 'region/:id', component: RegionSummaryComponent },
    { path: 'roadmap/:id', component: RoadmapComponent },
    { path: 'roadmap/:id/:version', component: RoadmapComponent },
    { path: 'admin', loadChildren: () => import('../features/admin/admin.routes').then((m) => m.ADMIN_ROUTES) },
  ] },
  { path: 'unauthorized', component: UnauthorizedComponent },
  { path: 'logout', component: LogoutComponent },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];
